import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { CustomerType } from '../customer-type';

export class CustomerTypeBuilder {

  static fromJson(json): CustomerType {
    return (json) ? new CustomerType(
      json.hash,
      json.name,
    ) : null;
  }

  static fromJsonList(list): CustomerType[] {
    return (isArray(list)) ? sortByString('name', mapCollection(CustomerTypeBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/customer-type-builder.ts